import React from "react";
import Modal from '../../component/Inc/Modal';
function PopConfirmInfo(props) {
  const { open, close, type } = props;
  return (
    <Modal open={open} close={close} type="com_input">
      { type === 'id' ? 
      <>
        <h2 className='pop_tit'>내 정보 확인</h2>
        <p className="pop_desc">내 정보 확인을 위해 다시 한 번 로그인 해주세요.</p>
        <div className="content_container scroll">
          <ul className='com_input_sec'>
            <li className='tit_field'>아이디</li>
            <li className='input_field'>
              <input type="text" className="input" placeholder="아이디를 입력해주세요" />
            </li>
            <li className='tit_field'>비밀번호 입력</li>
            <li className='input_field'>
              <input type="text" className="input" placeholder="영문, 숫자, 특수문자  8자 이상 입력" />
              <span className="error_txt">* 비밀번호가 일치하지 않습니다.</span>
            </li>
          </ul>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">확인</button>
        </div>
      </>
      : type === 'id_chg' ?
      <>
        {/* 아이디 변경 */}
        <h2 className='pop_tit'>아이디 변경</h2>
        <div className="content_container scroll">
          <ul className='com_input_sec'>
            <li className='tit_field'>비밀번호 입력</li>
            <li className='input_field'>
              <input type="text" className="input" placeholder="영문, 숫자, 특수문자  8자 이상 입력" />
              <span className="error_txt">* 비밀번호가 일치하지 않습니다.</span>
            </li>
            <li className='tit_field'>기존 아이디</li>
            <li className='input_field'>
              <input type="text" className="input" placeholder="아이디를 입력해주세요" />
              <span className="error_txt">* 아이디가 일치하지 않습니다.</span>
            </li>
            <li className='tit_field'>새로운 아이디 입력</li>
            <li className='input_field'>
              <input type="text" className="input" placeholder="8자 이상 입력" />
              <span className="error_txt">* 사용가능한 특수문자 ~ ! @ \ # $ % &lt; &gt; ^ & *</span>
            </li>
          </ul>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">변경하기</button>
        </div>
      </>
      :
      <>
        {/* 비밀번호 변경 */}
        <h2 className='pop_tit'>비밀번호 변경</h2>
        <div className="content_container scroll">
          <ul className='com_input_sec'>
            <li className='tit_field'>기존비밀번호</li>
            <li className='input_field'>
              <input type="text" className="input" placeholder="아이디를 입력해주세요" />
              <span className="error_txt">* 비밀번호가 정확하지 않습니다.</span>
            </li>
            <li className='tit_field'>새로운 비밀번호 입력</li>
            <li className='input_field'>
              <input type="text" className="input" placeholder="영문, 숫자, 특수문자  8자 이상 입력" />
              <span className="error_txt">* 사용가능한 특수문자 ~ ! @ \ # $ % &lt; &gt; ^ & *</span>
            </li>
            <li className='tit_field'>새로운 비밀번호 확인</li>
            <li className='input_field'>
              <input type="text" className="input" placeholder="영문, 숫자, 특수문자  8자 이상 입력" />
              <span className="error_txt">* 새로운 비밀번호가 일치하지 않습니다.</span>
            </li>
          </ul>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">변경하기</button>
        </div>
      </>
      }
    </Modal>
  );
}

export default PopConfirmInfo;